import { z } from 'zod';
export const AppEnvironmentSchema = z.enum(['production', 'training']);
/** GET /api/config - public, uncached, always available. */
export const AppConfigResponseSchema = z.object({
    environment: AppEnvironmentSchema,
    /** Always null - there is no automatic reset. Kept for API-shape stability. */
    nextResetAt: z.string().nullable(),
});
/**
 * POST /api/training/reset and POST /api/training/reset-stock - the literal
 * string "RESET" is required to confirm, plus the calling admin's own
 * current password (verified against their stored hash - see the route
 * handlers / `api/src/training/confirm-guard.ts`).
 */
export const TrainingResetRequestSchema = z.object({
    confirm: z.literal('RESET'),
    password: z.string().min(1),
});
//# sourceMappingURL=training.js.map